import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import BlockTypes from '../../types/BlockTypes';
import renderBlocks from '../utils/renderBlocks';
import FileHelpers from '../../helpers/FileHelpers';
import getBlockId from '../../utils/getBlockId';
import makeLightboxItems from '../utils/makeLightboxItems';
import Container from './components/Container';
import serializers from './serializers';
import LazyViewer from './components/LazyViewer';
export var schema = {
  blocks: _defineProperty({}, BlockTypes.PDF, {
    isVoid: true
  })
};

function onRemove(editor, node) {
  editor.removeNodeByKey(node.key);
}

export default (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$enableLightbox = _ref.enableLightbox,
      enableLightbox = _ref$enableLightbox === void 0 ? true : _ref$enableLightbox,
      _ref$decorator = _ref.decorator,
      decorator = _ref$decorator === void 0 ? function (x) {
    return x;
  } : _ref$decorator,
      _ref$onDownload = _ref.onDownload,
      onDownload = _ref$onDownload === void 0 ? function (x) {
    return x;
  } : _ref$onDownload,
      _ref$isMobile = _ref.isMobile,
      isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile;

  var Component = function Component(props) {
    return React.createElement(Container, Object.assign({
      enableLightbox: enableLightbox,
      onDownload: onDownload,
      onRemove: onRemove,
      isMobile: isMobile
    }, props.attributes, props));
  };

  return [_objectSpread({}, renderBlocks(_defineProperty({}, BlockTypes.PDF, decorator(Component))), {
    serializers: serializers,
    schema: schema
  }, makeLightboxItems(BlockTypes.PDF, {
    renderItem: function renderItem(item) {
      return React.createElement(LazyViewer, item);
    },
    getItems: function getItems(editor) {
      return editor.value.document.getBlocksByType(BlockTypes.PDF).map(function (node) {
        var imageData = node.data;
        var size = imageData.get('meta') && imageData.get('meta').size ? "".concat(FileHelpers.bytesToSize(imageData.get('meta').size)) : '';
        return {
          id: getBlockId(node),
          type: BlockTypes.PDF,
          url: imageData.get('url'),
          name: imageData.get('name'),
          createdBy: imageData.get('createdBy'),
          size: size
        };
      }).toJS();
    }
  }))];
});